define([
    'moment',
    '../../campaign/services/campaigns',
    '../services/profile',
    'moment-timezone',
    '../services/loginCheck',
], function (moment) {
    'use strict';

    return {
        name: 'editProfileCtrl',
        arguments: [
            '$filter',
            '$http',
            '$rootScope',
            '$sessionStorage',
            '$scope',
            '$state',
            '$timeout',
            'Campaigns',
            'ErrorHandler',
            'FileUpload',
            'LoginCheck',
            'Profile',
            'Settings',
            'Site',
            function (
                $filter,
                $http,
                $rootScope,
                $sessionStorage,
                $scope,
                $state,
                $timeout,
                Campaigns,
                ErrorHandler,
                FileUpload,
                LoginCheck,
                Profile,
                Settings,
                Site
            ) {
                $scope.today = new Date();

                $scope.$watchGroup(
                    [
                        'site.notificationSettings.timezone',
                        'user.profile.timezone',
                    ],
                    function (newValues) {
                        // If the user profile has a timezone, default to that
                        if (
                            newValues[1] &&
                            $scope.site &&
                            $scope.site.hasOwnProperty(
                                'notificationSettings'
                            ) &&
                            !$scope.site.notificationSettings.timezone
                        ) {
                            $scope.site.notificationSettings.timezone =
                                newValues[1];
                        }
                    }
                );

                $scope.userLoaded = false;
                $scope.user = {};
                $scope.loadUser = function () {
                    $scope.userLoaded = false;
                    $scope.user = Profile.getProfile(true, function () {
                        //Hide empty form until user is loaded
                        $scope.userLoaded = true;
                        if (
                            $scope.user &&
                            $scope.user.hasOwnProperty('profile')
                        ) {
                            if (!$scope.firstName) {
                                $scope.firstName =
                                    $scope.user.profile.first_name;
                            }
                            if (!$scope.lastName) {
                                $scope.lastName = $scope.user.profile.last_name;
                            }
                        }
                    });
                    $scope.settings = Settings.getSettings();
                    $scope.site = Site.getSite(false, function () {
                        //Hide empty form until user is loaded
                        $scope.siteLoaded = true;
                        $scope.savedDomain = $scope.site.domain;
                        $scope.editDomain = $scope.site.domain;
                    });
                };
                $scope.loadUser();

                $scope.addLeadStatus = function () {
                    if (!$scope.user.hasOwnProperty('leadStatuses')) {
                        $scope.user.leadStatuses = [];
                    }
                    $scope.user.leadStatuses.push({
                        name: '',
                    });
                };

                $scope.onFileSelect = function (
                    $event,
                    $files,
                    owner_id,
                    partialRefresh,
                    property
                ) {
                    if (!property) {
                        property = 'avatar';
                    }
                    $scope.photoErrors = false;

                    if (!$scope.user.profile.hasOwnProperty(property)) {
                        $scope.user.profile[property] = {};
                    }
                    if (!$scope.user.profile[property].hasOwnProperty('urls')) {
                        $scope.user.profile[property].urls = {};
                    }

                    angular.forEach($files, function (file) {
                        if (file.type.match('image.*')) {
                            var reader = new FileReader();

                            reader.onload = (function (theFile) {
                                return function (e) {
                                    $scope.user.profile[
                                        property
                                    ].urls.avatar_medium = e.target.result;
                                    $scope.user.profile[
                                        property
                                    ].urls.avatar_large = e.target.result;
                                };
                            })(file);

                            reader.readAsDataURL(file);
                        }

                        FileUpload.uploadImage(
                            file,
                            owner_id,
                            '',
                            'avatar_large',
                            property
                        )
                            .then(function (response) {
                                $scope.photoErrors = false;

                                if (partialRefresh) {
                                    $scope.user.profile[
                                        property
                                    ].urls.avatar_large = response.data;
                                } else {
                                    $scope.user = Profile.getProfile(true);
                                }
                                $rootScope.$broadcast('user-updated');
                            })
                            .catch(function (result) {
                                $scope.photoErrors = ErrorHandler.getMessage(
                                    result,
                                    'Your image failed to upload.  Please try again.'
                                );
                            });
                    });
                    $event.target.value = '';
                };

                $scope.removeLeadStatus = function (status) {
                    var i = $scope.user.leadStatuses.indexOf(status);
                    if (i > -1) {
                        $scope.user.leadStatuses.splice(i, 1);
                    }
                };

                $scope.saveProfile = function (form) {
                    if (form) {
                        form.submitted = true;
                    }
                    if (!form || form.$valid) {
                        $scope.profileErrors = false;

                        $scope.user
                            .$update()
                            .catch(function (result) {
                                LoginCheck.checkAuthError(result);

                                $scope.profileErrors = ErrorHandler.getMessage(
                                    result,
                                    'Error saving.  Please try again.'
                                );
                            })
                            .then(function () {
                                if (!$scope.profileErrors) {
                                    var newUser = Profile.getProfile(
                                        true,
                                        function () {
                                            $scope.user = newUser;
                                            $rootScope.$broadcast(
                                                'user-updated'
                                            );
                                        }
                                    );
                                    $scope.profileUpdated = true;
                                    $timeout(function () {
                                        $scope.profileUpdated = false;
                                    }, 5000);
                                    if (form) {
                                        form.submitted = false;
                                    }
                                    if ($state.is('profile.welcome')) {
                                        $scope.goToOnboardingStep('next');
                                    }
                                }
                            });
                    }
                };

                $scope.saveSite = function (form) {
                    if (form) {
                        form.submitted = true;
                    }
                    if (!form || form.$valid) {
                        $scope.siteErrors = false;

                        $scope.site.domain = $scope.editDomain;

                        var success = true;
                        $scope.site
                            .save()
                            .catch(function (result) {
                                LoginCheck.checkAuthError(result);

                                $scope.siteErrors = ErrorHandler.getMessage(
                                    result,
                                    'Error saving settings.  Please try again'
                                );
                                success = false;
                            })
                            .then(function (result) {
                                if (success) {
                                    $scope.siteUpdated = true;
                                    $timeout(function () {
                                        $scope.siteUpdated = false;
                                    }, 5000);
                                    if (form) {
                                        form.submitted = false;
                                        form.$setPristine();
                                        if (
                                            form.webhook &&
                                            form.webhook.$modelValue &&
                                            form.webhook.$dirty &&
                                            ($scope.site.hasAVMCampaigns ||
                                                $scope.site.hasEmailCampaigns ||
                                                $scope.site.hasSmsCampaigns)
                                        ) {
                                            $(
                                                '#disable-campaigns-modal'
                                            ).foundation('reveal', 'open');
                                        }
                                    }
                                    $scope.savedDomain = $scope.site.domain;

                                    if ($('#change-domain').length > 0) {
                                        $('#change-domain').foundation(
                                            'reveal',
                                            'close'
                                        );
                                    }
                                }
                            });
                    }
                };

                $scope.checkEmailCredentials = function () {
                    $scope.site.notificationSettings.emailCredentials.credentialsValid = true;

                    $scope.site.$checkEmailCredentials();
                };

                $scope.disableCampaigns = function (form) {
                    if (form.disableAVMCampaigns.$modelValue) {
                        $scope.site.disableAVMCampaigns();
                    }
                    if (form.disableEmailCampaigns.$modelValue) {
                        $scope.site.disableEmailCampaigns();
                    }
                    if (form.disableSmsCampaigns.$modelValue) {
                        $scope.site.disableSmsCampaigns();
                    }
                    $('#disable-campaigns-modal').foundation('reveal', 'close');
                    $('#disable-campaigns-confirm-modal').foundation(
                        'reveal',
                        'open'
                    );
                    Campaigns.resetCampaigns();
                };

                $scope.skipOnboarding = function () {
                    $scope.onboardingStep = null;
                    window.location.href = $rootScope.Routing.generate(
                        'settings_microsite_site'
                    );
                };
                $scope.previousOnboarding = function () {
                    if ($scope.onboardingStep > 1) {
                        $scope.onboardingStep--;
                    }
                };

                $scope.goToOnboardingStep = function (step) {
                    switch (step) {
                        case 'next':
                            if (
                                $scope.onboardingStep > 0 &&
                                $scope.onboardingStep < 6
                            ) {
                                $scope.onboardingStep++;
                                break;
                            }
                        case 'done':
                            $scope.onboardingStep = null;
                            window.location.href = $rootScope.Routing.generate(
                                'leads'
                            );
                            break;
                        case 'final':
                            $scope.onboardingStep = 6;
                            break;
                        default:
                            $scope.onboardingStep = step;
                            break;
                    }

                    if ($scope.onboardingStep >= 6) {
                        // Make sure the user's site is loaded for the URL display
                        $scope.site = Site.getSite(true);
                    }

                    if ($scope.onboardingStep > 6) {
                        $scope.skipOnboarding();
                    }
                };

                $scope.enableDynamicCities = function () {
                    $scope.settings.options.dynamicCityEnable = 1;
                    $scope.settings.save();
                    $scope.goToOnboardingStep('next');
                };

                $scope.updateCreditCard = function (form, postType) {
                    if (
                        form &&
                        form.$invalid &&
                        typeof Raven != 'undefined' &&
                        Raven
                    ) {
                        var errors = [];
                        angular.forEach(form.$error, function (
                            fields,
                            validationType
                        ) {
                            angular.forEach(fields, function (data) {
                                errors.push({
                                    field: data.$name,
                                    validationType: validationType,
                                });
                            });
                        });
                        Raven.captureException(
                            new Error(
                                'User submitted an invalid credit card form: ' +
                                    JSON.stringify(errors)
                            )
                        );
                    }

                    if (form.$valid && !form.loading) {
                        $scope.ccUpdated = false;
                        form.errors = false;
                        form.loading = true;

                        var firstTime = !$scope.user.creditCard;

                        if ($scope.firstName) {
                            $scope.user.profile.first_name = $scope.firstName;
                        }
                        if ($scope.lastName) {
                            $scope.user.profile.last_name = $scope.lastName;
                        }
                        $scope.user.$update();

                        Profile.updateCreditCard({
                            cc_num: $scope.cc_num,
                            cc_cvc: $scope.cc_cvc,
                            cc_exp: $scope.cc_exp,
                        })
                            .$promise.catch(function (result) {
                                LoginCheck.checkAuthError(result);

                                form.errors = ErrorHandler.getMessage(
                                    result,
                                    'Error saving.  Please try again.'
                                );
                                form.loading = false;

                                if (typeof Raven != 'undefined' && Raven) {
                                    Raven.captureException(
                                        new Error(
                                            'Error saving credit card: ' +
                                                JSON.stringify(form.errors)
                                        )
                                    );
                                }
                            })
                            .then(function () {
                                if (!form.errors) {
                                    $scope.ccUpdated = true;
                                    $sessionStorage.ccMessage =
                                        'Your credit card has been updated';

                                    // Do a full refresh so all backend permissions are re-set with new CC info
                                    if (postType == 'resume') {
                                        $scope.resumeStep = 'confirm';
                                        $(document).on(
                                            'close.fndtn.reveal',
                                            '[data-reveal]',
                                            function () {
                                                // Some page elements need to be re-parsed on the backend, so reloading the page
                                                location.reload();
                                            }
                                        );
                                    } else if (!firstTime) {
                                        if ($scope.user.cancelled) {
                                            // If the user just re-enabled their account, send them to update their domain.
                                            window.location.href = $rootScope.Routing.generate(
                                                'settings_microsite_site'
                                            );
                                        } else {
                                            window.location.href = $rootScope.Routing.generate(
                                                'profile_basic'
                                            );
                                        }
                                    } else {
                                        window.location.href = $rootScope.Routing.generate(
                                            'profile_welcome'
                                        );
                                    }
                                }
                            });
                    }
                };

                // Show success message after page reload when changing CC
                if ($sessionStorage.ccMessage) {
                    $scope.ccFlash = $sessionStorage.ccMessage;
                    $timeout(function () {
                        $scope.ccFlash = '';
                    }, 10000);
                    delete $sessionStorage.ccMessage;
                }

                $scope.updatePassword = function (isValid) {
                    if (isValid) {
                        var error = false;
                        $scope.user
                            .$updatePassword()
                            .catch(function (result) {
                                $scope.user.password.error = ErrorHandler.getMessage(
                                    result,
                                    'error'
                                );
                                error = true;
                            })
                            .then(function () {
                                if (!error) {
                                    $scope.user.password = {
                                        old: '',
                                        second: '',
                                        validate: '',
                                    };
                                    $scope.passwordUpdated = true;
                                    $timeout(function () {
                                        $scope.passwordUpdated = false;
                                    }, 5000);
                                }
                                error = false;
                            });
                    }
                };
                var timeoutPromise;
                var delayInMs = 400;
                $scope.$watch('editDomain', function (newValue, oldValue) {
                    $timeout.cancel(timeoutPromise); //does nothing, if timeout already done
                    timeoutPromise = $timeout(function () {
                        //Set timeout
                        $scope.domainResults = Profile.checkDomain(newValue);
                    }, delayInMs);
                });
                $scope.recheckDomain = function () {
                    if ($scope.editDomain) {
                        $scope.domainResults = Profile.checkDomain(
                            $scope.editDomain,
                            true
                        );
                    }
                };

                $scope.postRegister = function () {
                    $http
                        .get($rootScope.Routing.generate('post_register'))
                        .then(function () {
                            $scope.loadUser();
                        });
                };

                $scope.deleteLogoImage = function () {
                    $scope.user.$removeProfileLogo().catch(function (result) {
                        LoginCheck.checkAuthError(result);

                        $scope.profileErrors = ErrorHandler.getMessage(
                            result,
                            'Error saving.  Please try again.'
                        );
                    });
                };

                $scope.resetCancel = function () {
                    $scope.$emit('reset-cancel');
                };
            },
        ],
    };
});
